export enum EStatus {
  "SUCCESS" = "success",
  "FAILURE" = "fail",
  "FAILED" = "failed",
}
